export default "__VITE_PUBLIC_ASSET__baf5b9c8__"